/**
 * Legal document URLs.
 * Update these when the pages are published.
 */
export const LEGAL_URLS = {
  privacyPolicy: 'https://firezenk.github.io/tournaly_legal/privacy_policy',
  termsOfService: 'https://firezenk.github.io/tournaly_legal/terms_of_service',
};
